import { Component, OnInit } from '@angular/core';
import { _ } from 'underscore';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  showMainOption = true;
  showLogin = true;
  constructor(private router: Router) { }

  ngOnInit() {
    if (!_.isEmpty(sessionStorage.getItem('mainopt'))) {
      this.showMainOption = false;
    }
    const user = sessionStorage.getItem('userObj');
    if(user)
    {
      this.showLogin = false;
    }
  }

  gotoProfile(){
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if(result.hg_accountId){
        this.router.navigate(['user-settings', result.hg_accountId]);
      }else{
      this.router.navigate(['user-settings', result._id]);
      }
    }
    
  }
  
  logoutFun(){
    sessionStorage.clear();
    this.router.navigateByUrl('/');
  }

  showOption(path){
    sessionStorage.setItem('mainopt',path)
    this.router.navigateByUrl(path);
  }
  addClass(event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    const navheadElement = document.getElementById('navbarhead');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list-charcoal.png';
      navheadElement.classList.remove('parent');
    } else {
      elementObj.classList.remove('closeicn');
      elementObj.classList.add('listicn');
      elementObj['src'] = 'assets/images/close-charcoal.svg';
      navheadElement.classList.add('parent');
    }
  }

  faqus(){
    sessionStorage.setItem('faqFlag','faq');
    sessionStorage.removeItem('contcusFlag')
  }

  fcontactus(){
    sessionStorage.removeItem('faqFlag');
    sessionStorage.setItem('contcusFlag','contact')
  }
  mobhead(event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    const navheadElement = document.getElementById('navbarhead');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
      navElement.classList.remove('show');
      navheadElement.classList.remove('parent');
    }
  }
}
